<script lang="ts">
  let teamText = '[ Our Valued Partners ]'

  import txpipe from 'branding/valued-partners/txpipe.png'
  import dex_hunters from 'branding/valued-partners/dex-hunters.png'
  import fluid_tokens from 'branding/valued-partners/fluid-tokens.png'
  import sundae from 'branding/valued-partners/sundae.png'

  const valuedPartnerLogos = [dex_hunters, fluid_tokens, sundae, txpipe]
  const scrollingPartnerLogos = [...valuedPartnerLogos, ...valuedPartnerLogos]
</script>

<div class="flex flex-col items-center">
  <h2 class="font-graphik text-[16px] font-normal uppercase tracking-wider lg-desktop:text-[20px]">{teamText}</h2>

  <div class="flex flex-col lg-desktop:justify-between lg-desktop:pt-6">
    <div
      class="maskEffect max-w-[500px] self-center overflow-hidden whitespace-nowrap md:max-w-[800px] lg-desktop:max-w-[1440px]"
    >
      <ul
        class="flex w-max flex-wrap items-center gap-x-4 py-4 motion-safe:animate-valued-partners-infinite-scroll lg-desktop:space-x-28 lg-desktop:motion-safe:animate-valued-partners-infinite-scroll-lg-desktop"
      >
        {#each scrollingPartnerLogos as item, index (`${item}-${index}`)}
          <li aria-hidden={index >= valuedPartnerLogos.length}>
            <img
              src={item}
              class="max-h-[30px] max-w-[135px] lg-desktop:scale-125"
              alt="partner logo"
              loading="lazy"
              fetchpriority="low"
              decoding="async"
            />
          </li>
        {/each}
      </ul>
    </div>
    <div
      class="maskEffect max-w-[500px] self-center overflow-hidden whitespace-nowrap md:max-w-[800px] lg-desktop:hidden"
    >
      <ul
        class=" flex w-max flex-wrap items-center gap-x-4 py-4 motion-safe:animate-valued-partners-infinite-scroll-reverse"
      >
        {#each scrollingPartnerLogos as item, index (`${item}-${index}`)}
          <li aria-hidden={index >= valuedPartnerLogos.length}>
            <img
              src={item}
              class="max-h-[30px] max-w-[135px] lg-desktop:scale-125"
              alt="partner logo"
              loading="lazy"
              fetchpriority="low"
              decoding="async"
            />
          </li>
        {/each}
      </ul>
    </div>
  </div>
</div>

<style lang="postcss">
  .maskEffect {
    mask: linear-gradient(90deg, transparent, white 35%, white 55%, transparent);
  }
</style>
